import { LitElement, html, css } from 'lit';
import './propose-notification-modal';
import './propose-login-modal';
import './add-notification-modal';

class AvailabilityNotificationCreateButton extends LitElement {
  static properties = {
    isLogin: { type: Boolean, reflect: true},
    isPaidUser: { type: Boolean, reflect: true},
    isAdmin: { type: Boolean, reflect: true},
    isProposeModalOpen: { type: Boolean, reflect: true, attribute: false},
    hasCustomerId: { type: Boolean, reflect: true},
    disabled: { type: Boolean, reflect: true }
  }
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.isProposeModalOpen = false;
    this.isLogin = false;
    this.isPaidUser = false;
    this.isAdmin = false;
    this.hasCustomerId = false;
  } 
  updated(changedProperties) {
    
  }
  static styles = css`
  
  `
  openDialog() {
    this.isProposeModalOpen = true;
  }
  closeDialog() {
  }
  addNotification(event) {
    this.isProposeModalOpen = false;
    this.dispatchEvent(new CustomEvent('add-notification', event));
  }
  renderModal() {
    if(this.isLogin && !(this.isPaidUser || this.isAdmin)) {
      return html`
        <propose-notification-modal
          .isModalOpen="${this.isProposeModalOpen}"
          .hasCustomerId="${this.hasCustomerId}"
          @close="${() => this.isProposeModalOpen = false}"
        ></propose-notification-modal>
      `;
    }
    else if(!this.isLogin) {
      console.log('renderProposeLoginModal')
      return html`
        <propose-login-modal
          .isModalOpen="${this.isProposeModalOpen}"
          @close="${() => this.isProposeModalOpen = false}"
        ></propose-login-modal>
      `;
    }
    else {
      return html`
        <add-notification-modal
          .isModalOpen="${this.isProposeModalOpen}"
          @close="${() => this.isProposeModalOpen = false}"
          @add-notification="${this.addNotification}"
        ></add-notification-modal>
      `;
    }
  } 
  render() {
    return html`
      <div class="availability-notification-button" @click="${this.openDialog}">
        <slot></slot>
      </div>
      ${this.renderModal()}
    `;
  }
}
customElements.define('availability-notification-create-button', AvailabilityNotificationCreateButton);